export const REQUEST_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
};

export const DEFAULT_CHATBOT_ERROR_MESSAGE =
  'We ran into a problem. Please try again.';
